import { useChatStore } from "@/zapi-frontend/stores/chatStore";
import { LOCAL_STORAGE_KEYS, LS_DIFF_STORAGE, LS_ZAPI_CHAT_STORAGE, TLocalStorageKey } from "./keys";
import { transformChatStorage } from "./transformers/transformChatStorage";
import { transformDiffStorage } from "./transformers/transformDiffStorage";
import { useDiffStore } from "@/zapi-frontend/stores/diff";
import { usePresentationChatStore } from "@/zapi-frontend/pages/ProjectDetailsPage/ui/PresentationPage/hooks/usePresentationChat";
import { useChatAskStore } from "@/zapi-frontend/stores/chatAskStore";

// how it works:
// 1. We only keep defined items in localStorage. The ones that are not defined on the const list are cleared out.
// 2. We apply some transformations to particular storage records.
// 2.1. If the transformed record is a persisted zustand store, then
// a) in the store you should set skipHydration: true;
// b) in the end of this function you should call storeName.persist.rehydrate();
// it's needed for zustand to initialize only after these transformations are applied.
export function initializeLocalStorage() {
  if (!localStorage) return;

  const transforms: Record<string, (value: string | null) => string | null> = {
    [LS_ZAPI_CHAT_STORAGE]: transformChatStorage,
    [LS_DIFF_STORAGE]: transformDiffStorage
  };

  const allKeys = Object.keys(localStorage);
  for (const k of allKeys) {
    if (!LOCAL_STORAGE_KEYS.includes(k as TLocalStorageKey) && !k.startsWith("cookie-consent-")) {
      localStorage.removeItem(k);
      continue;
    }
    if (k in transforms) {
      const current = localStorage.getItem(k);
      const next = transforms[k](current);
      if (next === null) localStorage.removeItem(k);
      else localStorage.setItem(k, next);
    }
  }

  // rehydrate stores
  useChatStore.persist.rehydrate();
  useDiffStore.persist.rehydrate();
  usePresentationChatStore.persist.rehydrate();
  useChatAskStore.persist.rehydrate();
}
